import styled from 'styled-components'
import { cardisTheme } from '../../theme/cardisTheme'

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${cardisTheme.spacing.smallGap};
  padding: ${cardisTheme.spacing.smallGap} ${cardisTheme.spacing.contentGap};
  background: transparent;
  border: 2px solid ${cardisTheme.colors.primary};
  border-radius: 4px;
  color: ${cardisTheme.colors.primary};
  font-family: ${cardisTheme.fonts.body};
  font-size: ${cardisTheme.fontSizes.body};
  font-weight: ${cardisTheme.fontWeights.medium};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${cardisTheme.colors.primary};
    color: ${cardisTheme.colors.background};
  }

  &:active {
    transform: scale(0.98);
  }

  @media print {
    display: none;
  }
`

export const PlusIcon = styled.span`
  font-size: ${cardisTheme.fontSizes.large};
  font-weight: ${cardisTheme.fontWeights.bold};
  line-height: 1;
`
